import { render } from "./OrganizationMember.vue?vue&type=template&id=1a3418ba"
import script from "./OrganizationMember.vue?vue&type=script&lang=js"
export * from "./OrganizationMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__